import firebase from 'firebase/app';
import React, {useEffect, useState} from "react";
import EveryonesSmileImg from "../images/top__everyones-smile.png";
import './EveryonesSmile.scss';
import {Smile} from './Smile';
import {Store} from "../models/Store";

export const EveryonesSmile = (props: { mobile: boolean }) => {

    const [list, setList] = useState<any[]>([]);

    useEffect(() => {
        const ac = new AbortController();
        let isAborted = false;

        let arr: firebase.firestore.DocumentData[] = [];

        (async () => {
            if (isAborted) return;

            try {

                for await (let i of Store.smileList.makeIterator()) {
                    if (isAborted) break;
                    if (!i) break;

                    arr = [...arr, i];
                    setList(arr);

                    await new Promise((resolve, reject) => {
                        const timeoutId = setTimeout(resolve, 100);
                        ac.signal.addEventListener('abort', () => {
                            reject();
                            clearTimeout(timeoutId);
                        });
                    });
                }

            } catch (e) {
                console.info('canceled');
            }

        })();

        return () => {
            isAborted = true;
            ac.abort();
        };
    }, []);

    return (
        <div className={'everyones-smile'}>
            <div className='everyones-smile-title'><img src={EveryonesSmileImg} alt="" width={260} height={67}/>
            </div>

            <div className='everyones-smile-container'>
                {
                    list.map(item => (
                        <div key={item.id}>
                            <Smile data={item.data} mobile={true}/>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};